import React from "react"
import * as render from "./renderProps"
import { StyleMainWrapper } from "./styles"
import "./styles.css"
import useReceipt from "./useReceipt"
import Snackbar from "@material-ui/core/Snackbar"
import Alert from "@material-ui/lab/Alert"

function Receipt() {
  const stateReceiptProps = useReceipt()
  return (
    <>
      <StyleMainWrapper>{render.renderUI(stateReceiptProps)}</StyleMainWrapper>
      <Snackbar
        style={{ marginTop: 60 }}
        open={stateReceiptProps?.getOpen?.flag}
        autoHideDuration={3000}
        onClose={stateReceiptProps?.handleClose}
        message={stateReceiptProps?.getOpen?.message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          // onClose={stateReceiptProps?.handleClose}
          severity={stateReceiptProps?.getOpen?.severity}
        >
          {stateReceiptProps?.getOpen?.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export { Receipt }
export default Receipt
